import { ApiErrorData } from "./http.api";

export class ApiError<T = ApiErrorData> extends Error {
  status?: number;
  code?: string;
  errorId?: string;
  raw?: any;
  // If you store the payload, type it:
  payload?: T;

  constructor(message: string, opts?: Partial<T> & {
    status?: number;
    code?: string;
    errorId?: string;
    raw?: any;
  }) {
    super(message);
    this.name = 'ApiError';
    Object.assign(this, opts);
  }
}